export { default as LanguageToggle } from './LanguageToggleComponent';



// WEBPACK FOOTER //
// ./src/components/LanguageToggle/index.ts